import i18n from 'i18next'
import {initReactI18next} from 'react-i18next'

import en from './locales/en.json'
import ar from './locales/ar.json'
import da from './locales/da.json'
import nl from './locales/nl.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import el from './locales/el.json'
import hi from './locales/hi.json'
import id from './locales/id.json'
import it from './locales/it.json'
import ms from './locales/ms.json'
import no from './locales/no.json'
import pt from './locales/pt.json'
import ru from './locales/ru.json'
import es from './locales/es.json'
import sv from './locales/sv.json'
import uk from './locales/uk.json'

i18n.use(initReactI18next).init({
  debug: true,
  resources: {
    en: {translation: en},
    ar: {translation: ar},
    da: {translation: da},
    nl: {translation: nl},
    fr: {translation: fr},
    de: {translation: de},
    el: {translation: el},
    hi: {translation: hi},
    id: {translation: id},
    it: {translation: it},
    ms: {translation: ms},
    no: {translation: no},
    pt: {translation: pt},
    ru: {translation: ru},
    es: {translation: es},
    sv: {translation: sv},
    uk: {translation: uk},
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
})

export default i18n
